// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"15e90c6a","180":"30bf3ef4","229":"590a9cf5","295":"8f711aa6","331":"5b28077b","378":"d69cb324","394":"3415ab37","453":"14f71a6e","460":"bad321c8","477":"4a6234c1","504":"3ea39796","586":"2a13d13e","818":"99c07787","844":"76a202d9","888":"ee52f9a9"}[chunkId] + ".chunk.js";
};